import { useContext, useEffect, useState } from 'react'
import DebtCounter from '../core_ui/debt/DebtCounter'
import DepartmentList from '../core_ui/departments/DepartmentList'
import { GameContext } from '../App'
import UpgradeBar from '../core_ui/upgrades/UpgradeBar'
import PrestigeWidget from '../core_ui/prestige/PrestigeWidget'
import { version } from '../../../package.json'

export default function Game() {
	const gameState = useContext(GameContext)
	const [showUpgrades, setShowUpgrades] = useState(false)
	if (gameState === null) throw new Error('No gameState')

	useEffect(() => {
		if (showUpgrades) {
			document.body.style.overflow = 'hidden'
		} else {
			document.body.style.overflow = 'unset'
		}
	}, [showUpgrades])

	return (
		<div
			className={`min-h-screen cursor-default bg-purple-900 p-4 ${showUpgrades ? 'overflow-hidden' : null}`}
		>
			<div className="container mx-auto max-w-6xl">
				<div className="mb-6 rounded-lg bg-purple-800/50 p-4 backdrop-blur-sm">
					<DebtCounter />
					<button
						onClick={() => setShowUpgrades(true)}
						className="mt-4 w-full rounded-lg bg-purple-600 px-4 py-2 text-white transition-colors hover:bg-purple-700"
					>
						View Upgrades
					</button>
				</div>
				<div className="space-y-4">
					<div>
						<DepartmentList />
					</div>
					<PrestigeWidget />
				</div>
			</div>

			<div
				className={`fixed inset-0 z-50 bg-black/50 backdrop-blur-sm transition-all duration-300 ${showUpgrades ? 'opacity-100' : 'pointer-events-none opacity-0'}`}
				onClick={(e) => {
					if (e.target === e.currentTarget) {
						setShowUpgrades(false)
					}
				}}
				onTouchMove={(e) => {
					if (showUpgrades) {
						e.preventDefault()
					}
				}}
			>
				<div
					className="absolute bottom-0 w-full transform rounded-t-2xl bg-purple-800 shadow-lg transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]"
					style={{
						transform: showUpgrades ? 'translateY(0)' : 'translateY(100%)'
					}}
				>
					<div className="m-4 flex items-center justify-between">
						<h2 className="text-2xl font-bold text-purple-100">Upgrades</h2>
						<button
							onClick={() => setShowUpgrades(false)}
							className="rounded-full p-2 text-purple-100 hover:bg-purple-700"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
					<div className="max-h-[70vh] overflow-y-auto">
						<UpgradeBar />
					</div>
				</div>
			</div>
			<p className="mt-8 text-center text-purple-400">
				Hillary's Empire v{version}
			</p>
		</div>
	)
}
